<template>
  <div class="TableBox">
    <ul class="topTab clear">
      <li :class="tab == item.id ? 'active' : ''" @click="tabEvent(item.id)" v-for="(item,index) in tabList" :key="index">{{item.name}}</li>
      <div style="float:right;margin-top:10px">
        <template v-if="tab=='no_cost_order'">
          <div class="batchDelete" style="float:left;margin-right:10px;background:#d51414;border-color:#d51414" @click="batchDelete">批量删除</div>
          <div class="batchDelete" style="float:left;margin-right:10px;background:#FF9B3B;border-color:#FF9B3B;" @click="clearSelection">清空选中</div>
        </template>
        <el-date-picker style="width:160px" class="picker" @change="dateChange" v-model="timeMonth" type="month" size="mini" :clearable='false' value-format="yyyy-MM" placeholder="所属月份">
        </el-date-picker>
        <div class="batchDelete" style="float:right;margin-left:10px;" @click="exportEvent()">导出</div>
      </div>
    </ul>
    <ux-grid class="uxGridBox" ref="plxTable" :height="height" :checkboxConfig="{checkMethod: selectable, highlight: true}" @selection-change="selectionChange" @table-body-scroll="scroll" @filter-change="filterChange" show-footer-overflow="tooltip" show-overflow="tooltip" size="mini">
      <ux-table-column v-if="tab=='no_cost_order'" type="checkbox" align="center" fixed="left" width="40" />
      <ux-table-column v-for="item in columns" :key="item.id" :resizable="item.resizable" :field="item.prop" :title="item.label" :fixed="item.fixed" :width="tab == 'no_cost_order' ? item.width : ''" show-header-overflow='tooltip' align="center" />
    </ux-grid>
  </div>
</template>
<script>
import costColumnsJson from '@/components/Order/json/cost.js'
import incompleteColumnsJson from '@/components/Order/json/incomplete.js'
export default {
  data () {
    return {
      columns: [],
      tab: 'no_cost_order',
      tabList: [
        { id: 'no_cost_order', name: '未传成本单' },
        { id: 'no_income_order', name: '未传收入单' },
      ],
      timeMonth: '',
      height: 0,
      dataList: [],
      multipleSelection: [],
    }
  },
  created () {
    var date = new Date();
    if (date.getMonth() === 0) { // 默认值为上个月份；月份为 0 时处理跨年问题
      this.timeMonth = (date.getFullYear() - 1) + '-' + '12'
    } else {
      this.timeMonth = date.getFullYear() + '-' + (date.getMonth());
    }
    this.columns = this.tab == 'no_cost_order' ? costColumnsJson : incompleteColumnsJson
  },
  mounted () {
    this.height = document.documentElement.clientHeight - 209 > 400 ? document.documentElement.clientHeight - 209 : 400
    this.init()
  },
  methods: {
    exportEvent () {
      this.$exportOrder({ source: 'incomplete', dataList: this.dataList, name: '残缺订单表' })
    },
    tabEvent (tab) {
      this.tab = tab;
      this.columns = this.tab == 'no_cost_order' ? costColumnsJson : incompleteColumnsJson;
      this.$nextTick(() => {
        this.datas = this.dataList[tab] // 知道为啥datas不在 data()方法里面定义吗？嘻嘻
        this.$refs.plxTable.reloadData(this.datas)
      })

      this.$refs.plxTable.doLayout(true)
    },
    init () {
      // this.$refs.plxTable.clearSelection();//取消选择
      this.clearSelection()
      this.$loading(this.$loadingConfig)
      this.$axios.get(this.URL.BASEURL + this.URL.incompleteList, {
        params: {
          month: this.timeMonth,
        }
      }).then((res) => {
        var res = res.data;
        this.$loading(this.$loadingConfig).close()
        if (res && res.errno == 0) {
          var data = res.rst;
          this.dataList = data;
          this.datas = data[this.tab] // 知道为啥datas不在 data()方法里面定义吗？嘻嘻
          this.$refs.plxTable.reloadData(this.datas)
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.$loading(this.$loadingConfig).close()
      })
    },
    filterChange ({ column, property, values, datas, filters, $event }) {//表格筛选条件change
      var arr = [];
      arr = this.tags.filter((v) => {
        return v.name == column.title
      })
      if (arr.length > 0) {
        if (values.length == 0) {
          this.tags = this.tags.filter((v) => {
            return v.name != column.title
          })
        } else {
          arr[0].values = values.join(',')
        }
      } else {
        this.tags.push({
          property: property,
          name: column.title,
          values: values.join(',')
        })
      }
    },
    scroll ({ scrollTop, scrollLeft }) {
      this.scrollTop = scrollTop
    },
    selectable ({ row }) {//选择表格限制条件
      return row.id !== 2
    },
    selectionChange (row) {// 选中的行
      this.multipleSelection = row;
    },
    dateChange () {//下拉框改变
      this.init()
    },
    batchDelete () {//批量删除
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        this.$message({
          message: '未选择要删除的订单',
          type: 'warning'
        })
        return
      }
      this.$confirm('确定要删除所选中订单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var arr = [];
        this.multipleSelection.forEach((item) => {
          arr.push(item.id)
        })
        this.$loading(this.$loadingConfig)
        this.$axios.post(this.URL.BASEURL + this.URL.orderIncomeBatchDel, {
          id_list: arr
        }).then((res) => {
          var res = res.data;
          if (res && res.errno == 0) {
            this.$message({
              message: '删除成功！',
              type: 'success'
            })
            this.init({ page: 1 })
          } else {
            this.$loading(this.$loadingConfig).close()
            this.$message({
              message: res.err,
              type: 'warning'
            })
          }
        }).catch(() => {
          this.$loading(this.$loadingConfig).close()
        })
      }).catch(() => {
      });
    },
    clearSelection () {//清空选中
      this.$refs.plxTable.clearSelection();
      this.multipleSelection = [];
    },
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/css/tableStyle.scss";
.flex {
  display: flex;
}
.TableBox {
  padding: 15px;
  background: #fff;
  margin-top: 15px;
}
.topTab {
  color: #333333;
  font-size: 16px;
  line-height: 22px;
  border-bottom: 2px solid #eff3ff;
  margin-bottom: 20px;
  li {
    display: inline-block;
    padding: 15px 40px;
    cursor: pointer;
    &.active {
      color: #2662ff;
    }
  }
}
.batchDelete {
  height: 24px;
  line-height: 24px;
  font-size: 12px;
  text-align: center;
  border-radius: 4px;
  border: 1px solid #5b7bfe;
  background: #5b7bfe;
  color: #fff;
  margin-right: 16px;
  cursor: pointer;
  padding: 0 4px;
}
</style>


// WEBPACK FOOTER //
// src/components/Order/medium/incompleteList.vue